export enum DAY_IN_WEEK {
  MON = "月",
  TUES = "火",
  WED = "水",
  THU = "木",
  FRI = "金",
  SAT = "土",
  SUN = "日",
}
